import { render, staticRenderFns } from "./ivr-log.vue?vue&type=template&id=53c6235a&scoped=true&"
import script from "./ivr-log.vue?vue&type=script&lang=js&"
export * from "./ivr-log.vue?vue&type=script&lang=js&"
import style0 from "./ivr-log.vue?vue&type=style&index=0&id=53c6235a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c6235a",
  null
  
)

export default component.exports